"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var Section = function Section(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["children"]);
  return _react["default"].createElement(_Flex["default"], props, children);
};

Section.propTypes = (0, _extends2["default"])({}, _Flex["default"].propTypes);
Section.defaultProps = (0, _extends2["default"])({}, _Flex["default"].defaultProps, {
  width: "100%"
});
var _default = Section;
exports["default"] = _default;